import { ALIEN_ENCOUNTERS } from "./alien-encounters.js";
import type { ContractTermsBase } from "./contract-orders.js";
import { NPCS } from "./npcs.js";
import type { ContractDifficulty } from "./progression.js";
import { REGIONS } from "./world-layout.js";

export function alienContractTerms(
  templateId: string,
  difficulty: ContractDifficulty,
  base: ContractTermsBase,
): ContractTermsBase | null {
  const encounter = ALIEN_ENCOUNTERS.find((item) => item.templateId === templateId);
  if (!encounter) return null;
  const region = REGIONS.find((item) => item.id === encounter.sectorId);
  if (!region) throw new Error("Alien contract region must exist");
  const advanced = difficulty === "advanced";
  const goal = advanced ? 4 : 2;
  const names = encounter.requiredArchetypes.map((id) => NPCS[id].name);
  return {
    ...base,
    title: `${encounter.title}${advanced ? " / Зачистка" : ""}`,
    description: `В области «${region.name}» уничтожь чужих: ${names.join(", ")}. Требуется ${goal} боевых зачёта и хотя бы один корабль каждого указанного вида. Обычные пираты и другие виды не засчитываются.`,
    sectorId: encounter.sectorId,
    goal,
    credits: advanced ? "250" : "150",
    components: advanced ? 6 : 3,
    cargoKind: null,
    cargoGoal: 0,
    requiredArchetypes: [...encounter.requiredArchetypes],
    requiredSurveySites: [],
    requireElite: false,
    requireRescue: false,
    escort: null,
    objective: {
      name: "Уничтожь указанные виды чужих",
      ...encounter.objectivePoint,
      kind: "combat",
    },
  };
}
